import type { AsyncStatus } from "@react-hookz/web";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import { useInsightPackagesLoader } from "../../../../hooks/insightPackages/useInsightPackagesLoader";
import { isSuccess } from "../../../../utils/api.utils";
import { withInsightsRenderer } from "../withInsightsRenderer";

import { StandaloneRecommendationCard } from "./StandaloneRecommendationCard";

interface InsightPackagesProps {
    isLoaderInView: boolean;
    setAsyncStatus: Dispatch<SetStateAction<AsyncStatus>>;
    setTotalCount: Dispatch<SetStateAction<number>>;
}

export const InsightPackages: React.FunctionComponent<InsightPackagesProps> = (
    props: InsightPackagesProps,
) => {
    const { isLoaderInView, setAsyncStatus, setTotalCount } = props;
    const [asyncStatus, lazyLoadedInsights, totalResults] =
        useInsightPackagesLoader({
            isLoaderInView,
        });

    useEffect(() => {
        setAsyncStatus(asyncStatus);
    }, [asyncStatus]);

    useEffect(() => {
        if (isSuccess(asyncStatus)) {
            setTotalCount(totalResults);
        }
    }, [asyncStatus, totalResults]);

    return (
        <>
            {lazyLoadedInsights.map((recommendation, index) => (
                <StandaloneRecommendationCard
                    recommendation={recommendation}
                    key={index}
                    index={index}
                />
            ))}
        </>
    );
};

export const InsightPackagesViewer = withInsightsRenderer(InsightPackages);
